/* global saveAs, Blob, BlobBuilder, console */
/* exported ics */
import { saveAs } from 'file-saver';

function gics(uidDomain, prodId) {
    'use strict';

    if (navigator.userAgent.indexOf('MSIE') > -1 && navigator.userAgent.indexOf('MSIE 10') == -1) {
      console.log('Unsupported Browser');
      return;
    }

    if (typeof uidDomain === 'undefined') { uidDomain = 'default'; }
    if (typeof prodId === 'undefined') {
      prodId = 'Calendar';
    }

    var SEPARATOR = (navigator.appVersion.indexOf('Win') !== -1) ? '\r\n' : '\n';
    var calendarEvents = [];
    var calendarStart = [
      'BEGIN:VCALENDAR'+
      '\r\nPRODID:' + prodId +
      '\r\nVERSION:2.0'
    ].join(SEPARATOR);
    // var calendarEnd = SEPARATOR + 'END:VCALENDAR';
    var calendarEnd = "\r\n" + 'END:VCALENDAR';
    var BYDAY_VALUES = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

    return {
      /**
       * Returns events array
       * @return {array} Events
       */
      'events': function() {
        return calendarEvents;
      },

      /**
       * Returns calendar
       * @return {string} Calendar in iCalendar format
       */
      'calendar': function() {
        return calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;
      },

      /**
       * Add event to the calendar
       * @param  {string} subject     Subject/Title of event
       * @param  {string} description Description of event
       * @param  {string} location    Location of event
       * @param  {string} begin       Beginning date of event
       * @param  {string} stop        Ending date of event
       */
      'addEvent': function(subject, description, location, begin, stop, rrule, organizer_name, organizer_mail, attendees, status, UID) {
        // I'm not in the mood to make these optional... So they are all required
        if (typeof subject === 'undefined' ||
          typeof description === 'undefined' ||
          typeof location === 'undefined' ||
          typeof begin === 'undefined' ||
          typeof stop === 'undefined'
        ) {
          return false;
        }
        // validate rrule
        if (rrule) {
          if (!rrule.rrule) {
            if (rrule.freq !== 'YEARLY' && rrule.freq !== 'MONTHLY' && rrule.freq !== 'WEEKLY' && rrule.freq !== 'DAILY') {
              throw "Recurrence rrule frequency must be provided and be one of the following: 'YEARLY', 'MONTHLY', 'WEEKLY', or 'DAILY'";
            }

            if (rrule.until) {
              if (isNaN(Date.parse(rrule.until))) {
                throw "Recurrence rrule 'until' must be a valid date string";
              }
            }

            if (rrule.interval) {
              if (isNaN(parseInt(rrule.interval))) {
                throw "Recurrence rrule 'interval' must be an integer";
              }
            }

            if (rrule.count) {
              if (isNaN(parseInt(rrule.count))) {
                throw "Recurrence rrule 'count' must be an integer";
              }
            }

            if (typeof rrule.byday !== 'undefined') {
              if ((Object.prototype.toString.call(rrule.byday) !== '[object Array]')) {
                throw "Recurrence rrule 'byday' must be an array";
              }

              if (rrule.byday.length > 7) {
                throw "Recurrence rrule 'byday' array must not be longer than the 7 days in a week";
              }

              // Filter any possible repeats
              rrule.byday = rrule.byday.filter(function(elem, pos) {
                return rrule.byday.indexOf(elem) == pos;
              });

              for (var d in rrule.byday) {
                if (BYDAY_VALUES.indexOf(rrule.byday[d]) < 0) {
                  throw "Recurrence rrule 'byday' values must include only the following: 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'";
                }
              }
            }
          }
        }

        //TODO add time and time zone? use moment to format?
        var start_date = new Date(begin);
        var end_date = new Date(stop);
        var now_date = new Date();

        var start_year = ("0000" + (start_date.getFullYear().toString())).slice(-4);
        var start_month = ("00" + ((start_date.getMonth() + 1).toString())).slice(-2);
        var start_day = ("00" + ((start_date.getDate()).toString())).slice(-2);
        var start_hours = ("00" + (start_date.getHours().toString())).slice(-2);
        var start_minutes = ("00" + (start_date.getMinutes().toString())).slice(-2);
        var start_seconds = ("00" + (start_date.getSeconds().toString())).slice(-2);

        var end_year = ("0000" + (end_date.getFullYear().toString())).slice(-4);
        var end_month = ("00" + ((end_date.getMonth() + 1).toString())).slice(-2);
        var end_day = ("00" + ((end_date.getDate()).toString())).slice(-2);
        var end_hours = ("00" + (end_date.getHours().toString())).slice(-2);
        var end_minutes = ("00" + (end_date.getMinutes().toString())).slice(-2);
        var end_seconds = ("00" + (end_date.getSeconds().toString())).slice(-2);

        var now_year = ("0000" + (now_date.getFullYear().toString())).slice(-4);
        var now_month = ("00" + ((now_date.getMonth() + 1).toString())).slice(-2);
        var now_day = ("00" + ((now_date.getDate()).toString())).slice(-2);
        var now_hours = ("00" + (now_date.getHours().toString())).slice(-2);
        var now_minutes = ("00" + (now_date.getMinutes().toString())).slice(-2);
        var now_seconds = ("00" + (now_date.getSeconds().toString())).slice(-2);

        // var start_year = ("0000" + (start_date.getUTCFullYear().toString())).slice(-4);
        // var start_month = ("00" + ((start_date.getUTCMonth() + 1).toString())).slice(-2);
        // var start_day = ("00" + ((start_date.getUTCDate()).toString())).slice(-2);
        // var start_hours = ("00" + (start_date.getUTCHours().toString())).slice(-2);
        // var start_minutes = ("00" + (start_date.getUTCMinutes().toString())).slice(-2);
        // var start_seconds = ("00" + (start_date.getUTCSeconds().toString())).slice(-2);
        //
        // var end_year = ("0000" + (end_date.getUTCFullYear().toString())).slice(-4);
        // var end_month = ("00" + ((end_date.getUTCMonth() + 1).toString())).slice(-2);
        // var end_day = ("00" + ((end_date.getUTCDate()).toString())).slice(-2);
        // var end_hours = ("00" + (end_date.getUTCHours().toString())).slice(-2);
        // var end_minutes = ("00" + (end_date.getUTCMinutes().toString())).slice(-2);
        // var end_seconds = ("00" + (end_date.getUTCSeconds().toString())).slice(-2);
        //
        // var now_year = ("0000" + (now_date.getUTCFullYear().toString())).slice(-4);
        // var now_month = ("00" + ((now_date.getUTCMonth() + 1).toString())).slice(-2);
        // var now_day = ("00" + ((now_date.getUTCDate()).toString())).slice(-2);
        // var now_hours = ("00" + (now_date.getUTCHours().toString())).slice(-2);
        // var now_minutes = ("00" + (now_date.getUTCMinutes().toString())).slice(-2);
        // var now_seconds = ("00" + (now_date.getUTCSeconds().toString())).slice(-2);

        // Since some calendars don't add 0 second events, we need to remove time if there is none...
        var start_time = '';
        var end_time = '';
        if (start_hours + start_minutes + start_seconds + end_hours + end_minutes + end_seconds != 0) {
          start_time = 'T' + start_hours + start_minutes + start_seconds;
          end_time = 'T' + end_hours + end_minutes + end_seconds;
        }
        var now_time = 'T' + now_hours + now_minutes + now_seconds;

        var start = start_year + start_month + start_day + start_time;
        var end = end_year + end_month + end_day + end_time;
        var now = now_year + now_month + now_day + now_time;

        // recurrence rrule vars
        var rruleString;
        if (rrule) {
          if (rrule.rrule) {
            rruleString = rrule.rrule;
          } else {
            rruleString = 'RRULE:FREQ=' + rrule.freq;

            if (rrule.until) {
              var uDate = new Date(Date.parse(rrule.until)).toISOString();
              rruleString += ';UNTIL=' + uDate.substring(0, uDate.length - 13).replace(/[-]/g, '') + '000000Z';
            }

            if (rrule.interval) {
              rruleString += ';INTERVAL=' + rrule.interval;
            }

            if (rrule.count) {
              rruleString += ';COUNT=' + rrule.count;
            }

            if (rrule.byday && rrule.byday.length > 0) {
              rruleString += ';BYDAY=' + rrule.byday.join(',');
            }
          }
        }

        //---------------------------------------------------------------

          let organizer_string = '\r\nORGANIZER;CN=' + organizer_name + ':mailto:' + organizer_mail;
          let attend = "";
          //************************************************************************************************************

         //**IMPORTANT: Please, don't remove following commented for loop because it will be important at future
          // updates to set attendees into ICS via this ics generator

          // for (let att of attendees) {
          //   let val = '\r\nATTENDEE;ROLE=REQ-PARTICIPANT;PARTSTAT=NEEDS-ACTION;RSVP=TRUE;CN=' + att + ':mailto:' + att;
          //   attend = attend + val
          // }

        //************************************************************************************************************
          attend = "\r\nATTENDEE;";

        //---------------------------------------------------------------

        var stamp = new Date().toISOString();

        // var ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        // var ID_LENGTH = 20;
        // var generateUID = function() {
        //   var rtn = '';
        //   for (var i = 0; i < ID_LENGTH; i++) {
        //     rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
        //   }
        //   if(UID) {
        //
        //     return UID;
        //   } else {
        //     // return rtn+ "@" + uidDomain;
        //     return rtn+ "_" + "portal";
        //   }
        // }

        let s_m = 'CONFIRMED';
        let m_m = 'PUBLISH';
        let s_s = 0;
        switch (status) {
          case 1:
            s_m = 'CONFIRMED';m_m = 'PUBLISH'; break;
          case 2:
            s_m = 'REQUEST';
            m_m = 'REQUEST';
            s_s = Math.floor(Math.random() * 100) + 1;
            break;
          case 3:
            s_m = 'CANCELLED';
            m_m = 'REQUEST';
            s_s = Math.floor(Math.random() * 100) + 1;
            break;
          default:
            break;
        }
        // /\((.*)\)/.exec(new Date().toString())[1]
        var calendarEvent = [
          'METHOD:' + m_m +
          '\r\nBEGIN:VTIMEZONE' +
          '\r\nTZID:Sri Lanka Standard Time' +
          '\r\nBEGIN:STANDARD' +
          '\r\nDTSTART:16010101T000000' +
          '\r\nTZOFFSETFROM:+0530' +
          '\r\nTZOFFSETTO:+0530' +
          '\r\nEND:STANDARD' +
          '\r\nBEGIN:DAYLIGHT' +
          '\r\nDTSTART:16010101T000000' +
          '\r\nTZOFFSETFROM:+0530' +
          '\r\nTZOFFSETTO:+0530' +
          '\r\nEND:DAYLIGHT' +
          '\r\nEND:VTIMEZONE' +
          '\r\nBEGIN:VEVENT'+
          organizer_string +
          // attend +
          '\r\nUID:' + UID +
          '\r\nCLASS:PUBLIC' +
          '\r\nDESCRIPTION:' + description +
          '\r\nDTSTAMP;VALUE=DATE-TIME:' + now +
          '\r\nDTSTART;TZID=' + "Sri Lanka Standard Time"+':'+start +
          '\r\nDTEND;TZID=' + "Sri Lanka Standard Time"+':'+end +
          '\r\nSEQUENCE:' + s_s +
          '\r\nSTATUS:' + s_m +
          '\r\nSUMMARY;LANGUAGE=en-us:' + subject +
          '\r\nTRANSP:TRANSPARENT' +
          '\r\nLOCATION;LANGUAGE=en-US:' +
          '\r\nX-MICROSOFT-CDO-APPT-SEQUENCE:' + s_s +
          '\r\nX-MICROSOFT-CDO-OWNERAPPTID:' +
          '\r\nX-MICROSOFT-CDO-BUSYSTATUS:TENTATIVE' +
          '\r\nX-MICROSOFT-CDO-INTENDEDSTATUS:BUSY' +
          '\r\nX-MICROSOFT-CDO-ALLDAYEVENT:FALSE' +
          '\r\nX-MICROSOFT-CDO-IMPORTANCE:1' +
          '\r\nX-MICROSOFT-CDO-INSTTYPE:0' +
          '\r\nX-MICROSOFT-DONOTFORWARDMEETING:FALSE' +
          '\r\nX-MICROSOFT-DISALLOW-COUNTER:FALSE' +
          '\r\nX-MICROSOFT-LOCATIONDISPLAYNAME:' +
          '\r\nX-MICROSOFT-LOCATIONSOURCE:Device' +
          '\r\nX-MICROSOFT-LOCATIONURI:' +
          '\r\nX-MICROSOFT-LATITUDE:' +
          '\r\nX-MICROSOFT-LONGITUDE:' +
          '\r\nX-MICROSOFT-LOCATIONCITY:' +
          '\r\nX-MICROSOFT-LOCATIONSTATE:' +
          '\r\nX-MICROSOFT-LOCATIONCOUNTRY:' +
          '\r\nX-MICROSOFT-LOCATIONS:' +
          '\r\nEND:VEVENT'
        ];

        if (rruleString) {
          calendarEvent.splice(4, 0, rruleString);
          calendarEvent = [
            'METHOD:' + m_m +
            '\r\nBEGIN:VTIMEZONE' +
            '\r\nTZID:Sri Lanka Standard Time' +
            '\r\nBEGIN:STANDARD' +
            '\r\nDTSTART:16010101T000000' +
            '\r\nTZOFFSETFROM:+0530' +
            '\r\nTZOFFSETTO:+0530' +
            '\r\nEND:STANDARD' +
            '\r\nBEGIN:DAYLIGHT' +
            '\r\nDTSTART:16010101T000000' +
            '\r\nTZOFFSETFROM:+0530' +
            '\r\nTZOFFSETTO:+0530' +
            '\r\nEND:DAYLIGHT' +
            '\r\nEND:VTIMEZONE' +
            '\r\nBEGIN:VEVENT'+
            organizer_string +
            // attend +
            '\r\nUID:' + UID +
            '\r\nCLASS:PUBLIC' +
            '\r\nDESCRIPTION:' + description +"\r\n"+
            rruleString +
            '\r\nDTSTAMP;VALUE=DATE-TIME:' + now +
            '\r\nDTSTART;TZID=' + "Sri Lanka Standard Time"+':'+start +
            '\r\nDTEND;TZID=' + "Sri Lanka Standard Time"+':'+end +
            '\r\nSEQUENCE:' + s_s +
            '\r\nSTATUS:' + s_m +
            '\r\nSUMMARY;LANGUAGE=en-us:' + subject +
            '\r\nTRANSP:TRANSPARENT' +
            '\r\nLOCATION;LANGUAGE=en-US:' +
            '\r\nX-MICROSOFT-CDO-APPT-SEQUENCE:' + s_s +
            '\r\nX-MICROSOFT-CDO-OWNERAPPTID:' +
            '\r\nX-MICROSOFT-CDO-BUSYSTATUS:TENTATIVE' +
            '\r\nX-MICROSOFT-CDO-INTENDEDSTATUS:BUSY' +
            '\r\nX-MICROSOFT-CDO-ALLDAYEVENT:FALSE' +
            '\r\nX-MICROSOFT-CDO-IMPORTANCE:1' +
            '\r\nX-MICROSOFT-CDO-INSTTYPE:0' +
            '\r\nX-MICROSOFT-DONOTFORWARDMEETING:FALSE' +
            '\r\nX-MICROSOFT-DISALLOW-COUNTER:FALSE' +
            '\r\nX-MICROSOFT-LOCATIONDISPLAYNAME:' +
            '\r\nX-MICROSOFT-LOCATIONSOURCE:Device' +
            '\r\nX-MICROSOFT-LOCATIONURI:' +
            '\r\nX-MICROSOFT-LATITUDE:' +
            '\r\nX-MICROSOFT-LONGITUDE:' +
            '\r\nX-MICROSOFT-LOCATIONCITY:' +
            '\r\nX-MICROSOFT-LOCATIONSTATE:' +
            '\r\nX-MICROSOFT-LOCATIONCOUNTRY:' +
            '\r\nX-MICROSOFT-LOCATIONS:' +
            '\r\nEND:VEVENT'
          ];

        }

        calendarEvent = calendarEvent.join(SEPARATOR);
        let ce = calendarEvent;

        calendarEvents.push(calendarEvent);

        return calendarStart+"\r\n"+ce+calendarEnd ;
      },

      /**
       * Download calendar using the saveAs function from filesave.js
       * @param  {string} filename Filename
       * @param  {string} ext      Extention
       */
      'download': function(filename, ext) {
        if (calendarEvents.length < 1) {
          return false;
        }

        ext = (typeof ext !== 'undefined') ? ext : '.ics';
        filename = (typeof filename !== 'undefined') ? filename : 'calendar';
        var calendar = calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;

        var blob;
        if (navigator.userAgent.indexOf('MSIE 10') === -1) { // chrome or firefox
          blob = new Blob([calendar]);
        } else { // ie
          var bb = new BlobBuilder();
          bb.append(calendar);
          blob = bb.getBlob('text/x-vCalendar;charset=' + document.characterSet);
        }
        saveAs(blob, filename + ext);
        return calendar;
      },

      /**
       * Build and return the ical contents
       */
      'build': function() {
        if (calendarEvents.length < 1) {
          return false;
        }

        var calendar = calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;

        return calendar;
      }
    };
  };

export default gics;

